import { Box, Container, Grid, Paper } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'
import React from 'react'

const SkeletonLoadingManageOrder = () => {
  return (
    <Paper color="secondary" square variant="outlined" style={{ borderRadius: '4px' }}>
      <Box paddingY={4}>
        <Container className="container">
          <Grid container justifyContent="center">
            <Grid item md={8} xs={12}>
              <Box style={{ alignItems: 'center', display: 'flex', flex: '1 1 auto' }}>
                <Box>
                  <Skeleton height={100} variant="rect" width={100} />
                </Box>
                <Box display="flex" flexDirection="column" paddingLeft={'3em'}>
                  <Skeleton height={40} variant="rect" width={100} />
                  <Box paddingTop={'10px'}>
                    <Skeleton height={30} variant="rect" width={200} />
                  </Box>
                  <Box paddingTop={'10px'}>
                    <Skeleton height={40} variant="rect" width={100} />
                  </Box>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </Paper>
  )
}

export default SkeletonLoadingManageOrder
